export const areaConstants = {
    FETCH_QUOTAS_REQUEST: 'QUOTA_REQUEST',
    FETCH_QUOTAS_SUCCESS: 'QUOTA_SUCCESS',
    FETCH_QUOTAS_FAILURE: 'QUOTA_FAILURE',
};